import clsx from 'clsx'
import React, { useState } from 'react'

type ButtonPrimaryProps = {
  children: React.ReactNode
  onClick: () => void
  isDisabled?: boolean
  testId?: string
  styles?: React.CSSProperties
}

function ButtonPrimary ({
  children,
  onClick,
  isDisabled,
  testId,
  styles
}: ButtonPrimaryProps) {
  const [isHovered, setIsHovered] = useState(false)

  const buttonColorStyle = isDisabled
    ? { backgroundColor: 'rgb(229 231 235)' }
    : { backgroundColor: '#AD5BFF' }
  const hoveredStyle = isHovered && !isDisabled
    ? {
        backgroundColor: '#FFFFFF',
        color: '#AD5BFF',
        border: '1px solid #AD5BFF',
      }
    : { color: 'white' }

  return (
    <div
      data-testid={`button-primary${testId ? `-${testId}` : ''}`}
      className={clsx({
        'inline-block rounded-md py-2 px-4 mt-2 md:mt-0 text-center text-md font-medium shadow-sm border':
          true,
        'focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2':
          true,
        'h-10 flex justify-center align-center': true,
        'text-white cursor-pointer': !isDisabled,
        'text-gray-500 cursor-not-allowed': isDisabled,
      })}
      style={{
        transition: 'all 0.15s ease',
        width: '12rem',
        ...buttonColorStyle,
        ...hoveredStyle,
        ...styles,
      }}
      onClick={() => !isDisabled && onClick()}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </div>
  )
}

export default ButtonPrimary
